import * as React from 'react';

interface IllustrationProps {
  className?: string;
  dataHook?: string;
  illustration?: string | React.ReactNode;
}

export declare const Illustration: React.FunctionComponent<IllustrationProps>;
